import { Skeleton } from 'antd';
import styled from 'styled-components';

const SkeletonHeader = styled(Skeleton.Input)`
    height: 14px !important;
    width: 200px !important;
`;

export default SkeletonHeader;
